import React from 'react'
import PropTypes from 'prop-types'

import styles from './brand-logo.css'

function BrandLogo({
  logo
}) {
  if (!logo) return null

  return (
    <img className={styles.brandLogo} src={logo} alt="content brand logo" />
  )
}

BrandLogo.propTypes = {
  logo: PropTypes.string
}

BrandLogo.defaultProps = {
  logo: ''
}

export default BrandLogo
